import axios from 'axios';

if (!window.loan_data) {
  window.loan_data = {}
}

export default {
  amount: window.slider_amounts || [
    1000,
    2000,
    3000,
    4000,
    5000,
    6000,
    7000,
    8000,
    9000,
    10000,
    11000,
    12000,
    13000,
    14000,
    15000,
    16000,
    17000,
    18000,
    19000,
    20000,
    21000,
    22000,
    23000,
    24000,
    25000,
    26000,
    27000,
    28000,
    29000,
    30000,
    31000,
    32000,
    33000,
    34000,
    35000,
    36000,
    37000,
    38000,
    39000,
    40000,
    41000,
    42000,
    43000,
    44000,
    45000,
    46000,
    47000,
    48000,
    49000,
    50000,
    55000,
    60000,
    65000,
    70000,
    75000,
    80000,
    85000,
    90000,
    95000,
    100000,
    105000,
    110000,
    115000,
    120000,
    125000,
    130000,
    135000,
    140000,
    145000,
    150000,
    155000,
    160000,
    165000,
    170000,
    175000,
    180000,
    185000,
    190000,
    195000,
    200000,
    205000,
    210000,
    215000,
    220000,
    225000,
    230000,
    235000,
    240000,
    245000,
    250000,
    255000,
    260000,
    265000,
    270000,
    275000,
    280000,
    285000,
    290000,
    295000,
    300000,
    305000,
    310000,
    315000,
    320000,
    325000,
    330000,
    335000,
    340000,
    345000,
    350000,
    355000,
    360000,
    365000,
    370000,
    375000,
    380000,
    385000,
    390000,
    395000,
    400000,
    405000,
    410000,
    415000,
    420000,
    425000,
    430000,
    435000,
    440000,
    445000,
    450000,
    455000,
    460000,
    465000,
    470000,
    475000,
    480000,
    485000,
    490000,
    495000,
    500000,
  ],
  repayment: window.slider_periods || [
    6,
    12,
    24,
    36,
    48,
    60,
    72,
    84,
    96,
    108,
    120,
    132,
    144,
  ],
  default: {
    amount: window.default_slider_amount  || 25000,
    repayment: window.default_slider_period  || 48,
  },
  onChange(slider) {
    slider.link.setAttribute('href', slider.calculator.amount < 50000? `/snabblan/?amount=${slider.calculator.amount}&repayment=${slider.calculator.repayment}#loan-list` : `/privatlan/?amount=${slider.calculator.amount}&repayment=${slider.calculator.repayment}#loan-list`)
    axios
      .get(`/wp-admin/admin-ajax.php?action=slider_loans_count&amount=${slider.calculator.amount}&repayment=${slider.calculator.repayment}`)
      .then( resp => {
        slider.link.innerText = `Jämför ${resp.data.count} långivare`
      })

    // console.log('Filter homepage loans')

  },
}



// WEBPACK FOOTER //
// ./scripts/Data/homepage-loan.js